import { atom } from "recoil";
import { processInfo } from "../types/dirary";

export const processListState = atom<processInfo[]>({
  key: "processListState",
  default: [],
});

export const processListStateForMatrix = atom<processInfo[]>({
  key: "processListStateForMatrix",
  default: [],
});
